import React, { FunctionComponent } from "react";
import { useAnimation } from "../../hooks/useAnimate";
import Section from "../layout/Section";
import BodyText from "../typography/BodyText";
import { TitleHeading } from "../typography/TitleHeading";

type TextSectionProps = {
  tag: string;
  title: JSX.Element | string;
  text?: string | React.ReactNode;
  theme?: "dark" | "white" | "gray" | "indigo";
  titleBgTag?: boolean;
};

const TextSection: FunctionComponent<TextSectionProps> = ({
  tag,
  title,
  text,
  children,
  theme,
  titleBgTag,
}) => {
  const { id, animate } = useAnimation();

  return (
    <Section className="lg:max-w-4xl" id={id} theme={theme}>
      <div {...animate("fade-down", undefined, 120)}>
        <TitleHeading
          tag={tag}
          title={title}
          theme={theme}
          bgTag={titleBgTag}
        />
        <BodyText
          dark={theme === "dark" || theme == "indigo"}
          className="text-justify mt-6"
          mb="6"
        >
          {text}
        </BodyText>
        {children}
      </div>
    </Section>
  );
};

export default TextSection;
